import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import "react";
import { defaultSeriesColor } from "../tokens.esm.js";
const Circle = ({
  cx,
  cy,
  r,
  fill,
  id
}) => /* @__PURE__ */ jsx("circle", { cx, cy, r, fill: fill || defaultSeriesColor, id, className: "rd3-linechart-circle" });
Circle.propTypes = {
  cx: PropTypes.number,
  cy: PropTypes.number,
  fill: PropTypes.string,
  r: PropTypes.number,
  id: PropTypes.string
};
export {
  Circle as default
};
